<template>
    <div class="k2Pdf">
    <!--<vue-pdf-embed :source="source" :sdisableTextLayer="false"/>-->
    <vue-pdf-embed
            ref="pdfRef"
            :source="source"
            :page="page"
            @rendered="handleDocumentRender"
    />
    </div>
</template>


<script>
  // import VuePdfEmbed from 'vue-pdf-embed'
  import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

  export default {
    name: "K2PdfEmbed",
    created() {
    },
    components: {
      VuePdfEmbed
    },
    data() {
      return {
        isLoading: true,
        page: null,
        pageCount: 1
      };
    },
    props: ["source"],
    methods: {
      handleDocumentRender() {
        this.isLoading = false;
        this.pageCount = this.$refs.pdfRef.pageCount;
      }
    }
  };
</script>
<style>
    .k2Pdf .textLayer {
        z-index: 9999;
    }
</style>
